import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  const [showTooltip, setShowTooltip] = useState(() => {
    // Check if user has dismissed the tooltip
    return localStorage.getItem('languageTooltipDismissed') !== 'true';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  const dismissTooltip = () => {
    setShowTooltip(false);
    localStorage.setItem('languageTooltipDismissed', 'true');
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, showTooltip, dismissTooltip }}>
      {children}
    </LanguageContext.Provider>
  );
};
